import ModalFactory from '../factory';

import Content from './ReturnToQueueModal';

const ReturnToQueueModal = ModalFactory(Content);

export default ReturnToQueueModal;
